"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var header_menu_style_1 = require("./header-menu-style");
var header_menu_items_desktop_1 = require("./items/desktop/header-menu-items-desktop");
var header_menu_items_mobile_1 = require("./items/mobile/header-menu-items-mobile");
function HeaderMenu(props) {
    // const { items, activeItemIndex = 0, onSelectItem, onSelectSubItem, activeSubItemIndex } = props;
    // const { subHeaderItems, subHeaderType } = items[activeItemIndex] ?? {};
    return ((0, jsx_runtime_1.jsxs)(header_menu_style_1.StyledHeaderMenu, { title: "", children: [(0, jsx_runtime_1.jsx)(header_menu_items_desktop_1.HeaderMenuItemsDesktop, __assign({}, props)), (0, jsx_runtime_1.jsx)(header_menu_items_mobile_1.HeaderMenuItemsMobile, __assign({}, props))] }));
}
exports.HeaderMenu = HeaderMenu;
